'use strict';

const isKeyframesTarget = (v) => {
    return Array.isArray(v);
};

exports.isKeyframesTarget = isKeyframesTarget;
//# sourceMappingURL=is-keyframes-target.cjs.map
